import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MilestoneData } from '../../services/milestones/MilestoneData';
import {
  isConstructionStage,
  isDevelopmentStage,
  stageToHtmlChevron,
  stageToLabel,
} from '../../model/general/ProjectStage';
import { GovernanceGroup } from '../../model/milestones/GovernanceGroup';
import { ScheduleData } from '../../services/milestones/ScheduleData';
import { MilestoneDefinitions } from '../../services/milestones/MilestoneDefinitions';
import { UserMilestoneEntry } from './UserMilestoneEntry';
import { ValidatorUtil } from '../../ValidatorUtil';

@Component({
  selector: 'digires-milestone-list',
  templateUrl: './milestone-list.component.html',
  styleUrls: ['./milestone-list.component.scss'],
})
export class MilestoneListComponent implements OnChanges {
  readonly stageToChevronLabel = stageToHtmlChevron;
  readonly stageToLabel = stageToLabel;
  isDevelopmentStage = isDevelopmentStage;
  isConstructionStage = isConstructionStage;

  @Output() onDateClicked: EventEmitter<{ event: MouseEvent; data: MilestoneData }> = new EventEmitter<{
    event: MouseEvent;
    data: MilestoneData;
  }>();
  @Input() milestoneDefs: MilestoneDefinitions;
  @Input() governanceGroups: GovernanceGroup[];
  @Input() readOnly: boolean = false;
  @Input() readOnlyReason: string;
  @Input() canEditFid: boolean = false;
  @Input() projectCreation: boolean = false;

  @Input() scheduleData: ScheduleData;
  @Input() milestoneEntries: { [id: string]: MilestoneData };
  @Input() governanceSelectorFormGroup: FormGroup;
  @Input() currentStageFormGroup: FormGroup;
  @Input() userMilestoneFormGroup: FormGroup;

  userMilestoneEntries: UserMilestoneEntry[];
  nextUserMsIdx: number;

  ngOnChanges() {
    this.userMilestoneEntries = [];
    for (const fgMapping of Object.entries(this.userMilestoneFormGroup.controls)) {
      const id = fgMapping[0];
      const fg = fgMapping[1] as FormGroup;
      const fgValue = fg.getRawValue();
      this.userMilestoneEntries.push({
        id: id,
        initial: {
          name: fgValue.name,
          date: fgValue.date,
          done: fgValue.done,
        },
        fg: fg,
      });
    }
    this.nextUserMsIdx =
      this.userMilestoneEntries.length === 0
        ? 0
        : Math.max(...this.userMilestoneEntries.map((entry) => parseFloat(entry.id))) + 1;
  }

  onUserMilestoneAdd() {
    const entry: UserMilestoneEntry = {
      id: this.nextUserMsIdx++ + '',
      initial: {
        name: '',
        date: null,
        done: false,
      },
      fg: new FormGroup({
        name: new FormControl('', Validators.required),
        date: new FormControl(null, [Validators.required, ValidatorUtil.validateDate]),
        done: new FormControl(false),
      }),
    };
    this.userMilestoneFormGroup.addControl(entry.id, entry.fg);
    this.userMilestoneEntries.push(entry);
  }

  onUserMilestoneDelete(ms: UserMilestoneEntry) {
    const idx = this.userMilestoneEntries.indexOf(ms);
    if (idx <= -1) {
      console.error('Trying to delete invalid user milestone: ms=', ms, 'entries=', this.userMilestoneEntries);
      return;
    }
    this.userMilestoneFormGroup.removeControl(ms.id);
    this.userMilestoneEntries.splice(idx, 1);
  }
}
